import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { CommonActionPanelComponent } from '../../common/common-action-panel-component.directive';
import { ModifyCRMDataPanelComponent } from './modify-crm-data-panel/modify-crm-data-panel.component';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { ObjectType } from '@vendasta/auxiliary-data-components';

// There's no way to subclass an component without repeating the @Component
// so use this constant so you're not copy-pasting.
export const ModifyCRMDataPanelTemplate = `
  <automata-modify-crm-data-panel
    [step]="step"
    [title]="title"
    [automation]="automation"
    [precedingSteps]="precedingSteps"
    [branch]="branch"
    [viewTemplate]="viewTemplate"

    [objectType]="objectType"
    [taskDefinitionId]="taskDefinitionId"
    [panelTitle]="panelTitle"
    [panelSubtitle]="panelSubtitle"
    #workerComponent
  ></automata-modify-crm-data-panel>`;

@Component({
  template: '',
  imports: [],
})
export class ModifyCRMGenericDataPanelComponent extends CommonActionPanelComponent implements AfterViewInit {
  objectType!: ObjectType; // set this in child classes
  panelTitle!: string; // set this in child classes
  panelSubtitle!: string; // set this in child classes

  @ViewChild('workerComponent') workerComponent: ModifyCRMDataPanelComponent;

  ngAfterViewInit(): void {
    this.savingEnabled = true;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return this.workerComponent.getControlsToValidateOnSave();
  }

  getData(): any {
    return this.workerComponent.getData();
  }

  getRules(): RuleInterface[] {
    return this.workerComponent.getRules();
  }

  isFormValid(): boolean {
    return this.workerComponent.isFormValid();
  }
}
